export const getStudentToken = () => localStorage.getItem('auth_token');

export const studentHeaders = (headers = {}) => {
  const token = getStudentToken();

  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};
